import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import DataLoadingSpinner from 'components/global/DataLoadingSpinner';
import ServiceGroup from './ServiceGroup';

const ServicesAvailable = ({ availableServices }) => {
  const [loading, setLoading] = useState(true);
  const [mappedServices, setMappedServices] = useState({});

  const mapServices = () => {
    const servicesMapTemplate = {
      'Chronic Disease Management': {
        cdm_guided: false,
        chronic_disease_management: false,
      },
      'Mental Health': {
        children_mental_health: false,
        couples_counselling: false,
        crisis_support: false,
        first_step: false,
        icbt: false,
        icbt_coach_assisted: false,
        icbt_self_directed: false,
        icbt_therapist_led: false,
        in_person_counselling: false,
        individual_counselling: false,
        inmh: false,
        mental_health: false,
        peer_to_peer: false,
        specialized_clinical_services: false,
        substance_use_management: false,
      },
      Pharmacy: {
        health_store: false,
        pharmacy: false,
        specialty_pharmacy: false,
      },
      Telemedicine: {
        medical_second_opinion: false,
        mso: false,
        telemedicine: false,
      },
      'Well-being': {
        fitness: false,
        resl: false,
        well: false,
      },
      'Total Health and Life Services': {
        care: false,
        care_nav_premium: false,
        career_coaching: false,
        clinical_navigation: false,
        collaborative_care: false,
        emergency_financial_relief_program: false,
        ergonomic_assessments: false,
        financial_advisory: false,
        health_coaching: false,
        health_plus: false,
        hormonal_health: false,
        hormonal_health_sponsored: false,
        legal_advisory: false,
        life_transitions: false,
        personalized_nutrition: false,
        personalized_nutrition_sponsored: false,
      },
    };

    Object.keys(servicesMapTemplate).forEach(category => {
      Object.keys(servicesMapTemplate[category]).forEach(serviceCode => {
        if (availableServices[serviceCode]) {
          servicesMapTemplate[category][serviceCode] = true;
        }
      });
    });

    return servicesMapTemplate;
  };

  useEffect(() => {
    setLoading(true);
    const transformedServices = mapServices();
    setMappedServices(transformedServices);
    setLoading(false);
  }, [availableServices]);

  if (loading) {
    return <DataLoadingSpinner />;
  }

  return (
    <div style={{ marginTop: '32px' }}>
      {mappedServices['Mental Health'] && (
        <ServiceGroup
          categoryName={<FormattedMessage defaultMessage="Mental Health" />}
          services={mappedServices['Mental Health']}
        />
      )}
      {mappedServices['Chronic Disease Management'] && (
        <ServiceGroup
          categoryName={
            <FormattedMessage defaultMessage="Chronic Disease Management" />
          }
          services={mappedServices['Chronic Disease Management']}
        />
      )}
      {mappedServices.Pharmacy && (
        <ServiceGroup
          categoryName={<FormattedMessage defaultMessage="Pharmacy" />}
          services={mappedServices.Pharmacy}
        />
      )}
      {mappedServices.Telemedicine && (
        <ServiceGroup
          categoryName={<FormattedMessage defaultMessage="Telemedicine" />}
          services={mappedServices.Telemedicine}
        />
      )}
      {mappedServices['Well-being'] && (
        <ServiceGroup
          categoryName={<FormattedMessage defaultMessage="Well-being" />}
          services={mappedServices['Well-being']}
        />
      )}
      {mappedServices['Total Health and Life Services'] && (
        <ServiceGroup
          categoryName={
            <FormattedMessage defaultMessage="Total Health and Life Services" />
          }
          services={mappedServices['Total Health and Life Services']}
        />
      )}
    </div>
  );
};

ServicesAvailable.propTypes = {
  availableServices: PropTypes.object.isRequired,
};

export default ServicesAvailable;
